import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import { useForm } from "react-hook-form";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { Col, Row } from "react-bootstrap";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";

export const Management = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });
  const [userId, setUserId] = useState(null);
  const defaultValues = {
    name: "",
    Family: "",
    uid: "",
    mob: "",
    controlSidebar: 0,
    users: 0,
    makepage: 0,
    features: 0,
    shop: 0,
    insurance: 0,
    payment: 0,
    buy: 0,
    "*": 0,
  };
  const cols = [
    {
      field: "name",
      header: "نام",
    },
    { field: "Family", header: "نام خانوادگی" },
    {
      field: "mob",
      header: " شماره موبایل",
    },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  const handleOpeEditItem = (data) => {
    if (data) {
      fetchAdminsState(data);
      setUserId(data?.uid);
      setIsEditMode(true);
      reset({ ...defaultValues, ...data });
    } else {
      setIsEditMode(false);
      reset(defaultValues);
    }
    setShowEditComponent(true);
  };
  useEffect(() => {
    fetchData("adminlist", {}, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    setPageData(data?.dt);
    reset({ ...defaultValues, ...data?.dt });
  };

  const fetchAdminsState = async (rowData) => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", rowData?.uid);

    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "getadminpermission",
        },
      });
      if (response.status === 200) {
        const data = await response;
        const pages = {};
        for (let item of data?.data?.dt) {
          pages[item.pagename] = item.val;
        }
        reset({
          ...defaultValues,
          ...pages,
          ...rowData,
        });
        setIsEditMode(true);
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const schema = yup.object({
    mob: yup
      .string()
      .required("شماره موبایل نشده است.")
      .min(11, "شماره موبایل وارد شده نباید کمتر از 4 کاراکتر باشد."),
  });
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const pagesList = [
    "controlSidebar",
    "users",
    "makepage",
    "features",
    "shop",
    "insurance",
    "payment",
    "buy",
    "all",
  ];

  const setAdiminPermission = async (value, fieldName) => {
    const bodyFormData = new FormData();
    if (fieldName === "all") {
      bodyFormData.append("pageName", "*");
    } else {
      bodyFormData.append("pageName", fieldName);
    }
    bodyFormData.append("val", value);
    bodyFormData.append("mob", watch("mob"));

    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "setadminpermission",
        },
      });
      if (response.status === 200) {
        fetchData("adminlist", {}, handleApiResponse);
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };

  const handleLiveCheckBoxChange = (e) => {
    setAdiminPermission(e.target.checked, e.target.name);
  };
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"مدیریت پرسنل"}>
      <DataTableTemplate
        lazyState={lazyState}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={pageData}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
        paginator={false}
      />
      <div className="col-6 mt-5">
        <div className="d-flex flex-row gap-1 mt-2 mb-2">
          <Button className="btn-primary" onClick={() => handleOpeEditItem()}>
            افزودن ادمین جدید
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش ادمین" : "افزودن ادمین جدید"}
            </span>
          </div>
          <div className="panel-body">
            <Form dir="rtl">
              <Row>
                <Col className=" col-12 col-lg-4">
                  <TelInput
                    control={control}
                    name="mob"
                    type={"tel"}
                    defaultValue={""}
                    label="شماره موبایل"
                    errors={errors}
                    required={true}
                    readOnly={isEditMode}
                    maxLength={11}
                  />
                </Col>
              </Row>
              <Row className="mb-2 fw-bold">
                <Col className=" col-12 col-lg-12">
                  {/* <CheckboxFormat
                    control={control}
                    name="*"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل دسترسی به همه"
                  /> */}
                    <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1">کنترل دسترسی به همه</Form.Label>
                    <SelectButtonFormat
                      name={"*"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    onChange={handleLiveCheckBoxChange}
                    name="controlSidebar"
                    errors={errors}
                    type="checkbox"
                    label="کنترل ساید بار"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-2">کنترل منو ساید بار</Form.Label>
                    <SelectButtonFormat
                      name={"controlSidebar"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>{" "}
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="users"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل امور مشتریان"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-2 ">کنترل امور مشتریان </Form.Label>
                    <SelectButtonFormat
                      name={"users"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="makepage"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل ایجاد صفحه"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-2">کنترل ایجاد صفحه</Form.Label>
                    <SelectButtonFormat
                      name={"makepage"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>{" "}
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="features"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل ویژگی ها"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-2">کنترل ویژگی ها</Form.Label>
                    <SelectButtonFormat
                      name={"features"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>
              </Row>{" "}
              <Row className="mb-1">
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="shop"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل فروشگاه ها"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1">کنترل فروشگاه ها</Form.Label>
                    <SelectButtonFormat
                      name={"shop"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>{" "}
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="insurance"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل بیمه نامه"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1">کنترل بیمه نامه</Form.Label>
                    <SelectButtonFormat
                      name={"insurance"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>
              </Row>{" "}
              <Row className="mb-1">
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="payment"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل پرداخت ها"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1 ">کنترل پرداخت ها</Form.Label>
                    <SelectButtonFormat
                      name={"payment"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>{" "}
                <Col className=" col-12 col-lg-4">
                  {/* <CheckboxFormat
                    control={control}
                    name="buy"
                    onChange={handleLiveCheckBoxChange}
                    errors={errors}
                    type="checkbox"
                    label="کنترل خریدها"
                  /> */}
                  <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1 ">کنترل خریدها</Form.Label>
                    <SelectButtonFormat
                      name={"buy"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </>
      )}
    </PanelContainer>
  );
};
